import { type RevokeTokenRequest } from './aliases';

import {
  AUTH_IDENTIFY_ENDPOINT,
  REVOKE_TOKEN_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';

export function identify() {
  return typedHttp.get(AUTH_IDENTIFY_ENDPOINT, { withAuth: true });
}

export function revokeAccessToken(token: string) {
  if (!token) {
    return;
  }
  const body: RevokeTokenRequest = { token };

  return typedHttp
    .post(REVOKE_TOKEN_ENDPOINT, body)
    .catch(function discardError(_) {
      return;
    });
}
